import React from "react";
import PageBreadcrumb from "../../common/PageBreadcrumb/PageBreadcrumb";
import { EpsfCrumbStudySite } from "./epsfLedgerUi";

/**
 * ePSF page breadcrumb with Study / Site on the far right of the row.
 * Merges any caller trailingExtras after the context selectors.
 */
export default function EpsfPageBreadcrumb({
  trailingExtras = null,
  ...rest
}) {
  return (
    <PageBreadcrumb
      {...rest}
      trailingExtras={
        <>
          {trailingExtras}
          <EpsfCrumbStudySite />
        </>
      }
    />
  );
}
